import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useAccountStore = defineStore('account', {
  state: () => ({}),
  getters: {},
  actions: {
    updateFirstName: async function(payload) {
      const response = await Api.account.updateFirstName(payload);
      return response.data;
    },
    updateLastName: async function(payload) {
      const response = await Api.account.updateLastName(payload);
      return response.data;
    },
    updateNotificationSetting: async function(payload) {
      const response = await Api.account.updateNotificationSetting(payload);
      return response.data;
    },
    updateLanguage: async function(payload) {
      const response = await Api.account.updateLanguage(payload);
      return response.data;
    },
    updateEmailAddress: async function(payload) {
      const response = await Api.account.updateEmailAddress(payload);
      return response.data;
    },
    changeTheme: async function(payload) {
      const response = await Api.account.changeTheme(payload);
      return response.data;
    },
    changeFolderView: async function(payload) {
      const response = await Api.account.changeFolderView(payload);
      return response.data;
    },
    getUsage: async function(payload) {
      const response = await Api.account.getUsage(payload);
      return response.data;
    },
    getStorageUsage: async function(payload) {
      const response = await Api.account.getStorageUsage(payload);
      return response.data;
    },
    getAccountDeletionInfo: async function() {
      const response = await Api.account.getAccountDeletionInfo();
      return response.data;
    },
    deleteAccount: async function() {
      const response = await Api.account.deleteAccount();
      return response.data;
    },
  },
});
